import Axios from 'axios';

//const BASE_URL = '/api/settings/';



export default {

    getAll() {
        const BASE_URL = '/public/api/settings';
        return Axios.get(BASE_URL);
    },
    add(data) {
        const BASE_URL = '/public/api/settings';
        return Axios.post(BASE_URL, data);
    },

    update(data) {
        const BASE_URL = '/public/api/settings';
        return Axios.put(BASE_URL + data.id, data);
    },

    delete(id) {
        const BASE_URL = '/public/api/settings';
        return Axios.delete(BASE_URL + id);
    }

}